export enum DashboardColorGraphEnum {
  RED = "Red",
  PURPLE = "Purple",
  GREEN = "Green",
}
